// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__-8VsP","label":"Radio_label__vPNTX","checkMark":"Radio_checkMark__34DOs","disabled":"Radio_disabled__2cTQt"};